/* eslint-disable no-undef */
import NiceSelect from "nice-select2";

document.addEventListener('DOMContentLoaded', function () {
    // console.log('dealers');

    function niceSelect() {
        let select = document.getElementById('dealers-region');
  
        if (select) {
          const selectedOption = select.options[select.selectedIndex];
          const placeholderText = selectedOption && selectedOption.value ? selectedOption.value : 'Region';
        
          const options = {
            searchable: true,
            placeholder: placeholderText,
            searchtext: 'Välj',
          };
      
          let instance = new NiceSelect(select, options);
    
          setTimeout(() => {
            const searchInputs = document.querySelectorAll('.nice-select-search-box input');
            
            function normalizeText(text) {
              return text
                .replace(/\s+/g, '')
                .replace(/[üÜ]/g, 'u')
                .replace(/[öÖ]/g, 'o')
                .replace(/[äÄåÅ]/g, 'a')
                .toLowerCase();
            }
      
            searchInputs.forEach(input => {
              const list = input.closest('.nice-select').querySelector('.list');
              const listItems = list.querySelectorAll('li');
      
              input.addEventListener('input', function () {
                const searchValue = normalizeText(input.value);
      
                listItems.forEach(item => {
                  const text = normalizeText(item.textContent);
                  item.style.display = text.includes(searchValue) ? '' : 'none';
                });
              });
            });
          }, 100);
        } else {
          console.warn('No element found with ID');
        }
    }
    
    niceSelect();

    function updateUrlParam(regionSlug) {
        const newUrl = new URL(window.location.href);
    
        if (regionSlug) {
          newUrl.searchParams.set('region', regionSlug);
        } else {
          newUrl.searchParams.delete('region');
        }
        window.history.pushState({}, '', newUrl);
    }

    function getUrlParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    function regionRedirect() {
        const regionFromUrl = getUrlParam('region');
        if (regionFromUrl) {
            const regionSelect = document.getElementById('dealers-region');
            if (regionSelect) {
                regionSelect.value = regionFromUrl;
                const niceSelectWrapper = document.querySelector('.nice-select');
                if (niceSelectWrapper) {
                    const selectedOptionText = regionSelect.options[regionSelect.selectedIndex].textContent;
                    niceSelectWrapper.querySelector('.current').textContent = selectedOptionText;
                    const dropdownItems = niceSelectWrapper.querySelectorAll('.list li');
                    dropdownItems.forEach(li => li.classList.remove('selected'));
                    const selectedDropdownItem = Array.from(dropdownItems).find(li => li.dataset.value === regionFromUrl);
                    if (selectedDropdownItem) {
                        selectedDropdownItem.classList.add('selected');
                    }
                }
                // Set flag to prevent auto-load after region redirect
                justFiltered = true;
                filterDealers(regionFromUrl);
                
                // Reset flag after a delay
                setTimeout(() => {
                    justFiltered = false;
                }, 1000);
            }
        }
    }

    function filterDealers(regionSlug = '') {
        updateUrlParam(regionSlug);
        const filterForm = document.getElementById('dealers-filter-form');
        if (!filterForm) return;

        const selectedVehicleTypes = Array.from(document.querySelectorAll('input[name="vehicle_type[]"]:checked')).map(input => input.value);
        const ajaxUrl = SiteVars.ajaxUrl;
        const dealersList = document.querySelector('.dealers-page__list');
        const submitList = document.querySelector('.dealers-page__filter--submit');
        dealersList.classList.add('loading');
        submitList.classList.add('loading--data');

        const data = new FormData();
        data.append('action', 'filter_dealers');
        data.append('page', '1'); // Reset to first page when filtering
        selectedVehicleTypes.forEach(type => data.append('vehicle_type[]', type));
        data.append('region', regionSlug);

        fetch(ajaxUrl, {
            method: 'POST',
            credentials: 'same-origin',
            body: data,
        })
        .then(response => response.json())
        .then(response => {
            if (response.success) {
                
                // Clear the list completely (including old pagination elements)
                dealersList.innerHTML = '';
                
                // Add new content
                dealersList.innerHTML = response.data.html;
                
                updatePaginationInfo(response.data);
                const countSpan = document.querySelector('.dealers-page__filter--count');
                if (countSpan) {
                    countSpan.textContent = 'Visar ' + response.data.count + ' av ' + response.data.total_count + ' resultat';
                }
                
                // Scroll to the very top of the page after filtering
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
                
                // Set flag to prevent auto-load after filtering
                justFiltered = true;
                
                // Reset flag after a delay to allow normal scrolling
                setTimeout(() => {
                    justFiltered = false;
                }, 1000); // 1 second delay
            } else {
                console.error('Error in AJAX response:', response);
            }
        })
        .catch(error => {
            console.error('Error in AJAX request:', error);
        })
        .finally(() => {
            dealersList.classList.remove('loading');
            submitList.classList.remove('loading--data');
        });
    }

    function loadMoreDealers() {
        
        const paginationInfo = document.querySelector('.dealers-page__pagination-info');
        if (!paginationInfo) {
            return Promise.resolve();
        }

        const currentPage = parseInt(paginationInfo.dataset.page);
        const totalPages = parseInt(paginationInfo.dataset.totalPages);
        const selectedVehicleTypes = Array.from(document.querySelectorAll('input[name="vehicle_type[]"]:checked')).map(input => input.value);
        const selectedRegion = document.querySelector('select[name="region"]')?.value || '';
        const ajaxUrl = SiteVars.ajaxUrl;

        // Check if we can load more
        if (currentPage >= totalPages) {
            return Promise.resolve();
        }

        // Show loading indicator
        paginationInfo.classList.add('loading');

        const data = new FormData();
        data.append('action', 'filter_dealers');
        data.append('page', currentPage + 1);
        selectedVehicleTypes.forEach(type => data.append('vehicle_type[]', type));
        data.append('region', selectedRegion);

        return fetch(ajaxUrl, {
            method: 'POST',
            credentials: 'same-origin',
            body: data,
        })
        .then(response => {
            return response.json();
        })
        .then(response => {
            
            if (response.success) {
                // Append new dealers to the list
                const dealersList = document.querySelector('.dealers-page__list');
                const paginationContainer = dealersList.querySelector('.dealers-page__pagination-info');
            
                
                if (paginationContainer) {
                    // First, append new dealers before the pagination container
                    paginationContainer.insertAdjacentHTML('beforebegin', response.data.html);
                    
                    // Then remove old pagination info elements, but keep one for future loads
                    const oldPaginationElements = dealersList.querySelectorAll('.dealers-page__pagination-info');
                    
                    // Remove all but the last one to prevent duplication
                    if (oldPaginationElements.length > 1) {
                        for (let i = 0; i < oldPaginationElements.length - 1; i++) {
                            oldPaginationElements[i].remove();
                        }
                    }
                    
                    // Check if pagination element still exists after removal
                    const remainingPaginationElements = dealersList.querySelectorAll('.dealers-page__pagination-info');
                }
                
                // Update pagination info
                updatePaginationInfo(response.data);
                
                // Update count
                const countSpan = document.querySelector('.dealers-page__filter--count');
                if (countSpan) {
                    countSpan.textContent = 'Visar ' + (dealersList.querySelectorAll('.dealer-item').length) + ' av ' + response.data.total_count + ' resultat';
                }
                
                
                // Set flag to prevent auto-load after loading more
                justFiltered = true;
                
                // Reset flag after a delay
                setTimeout(() => {
                    justFiltered = false;
                }, 500); // Shorter delay for load more
                
            } else {
                console.error('Error in AJAX response:', response);
            }
        })
        .catch(error => {
            console.error('Error in AJAX request:', error);
        })
        .finally(() => {
            // Hide loading indicator
            paginationInfo.classList.remove('loading');
        });
    }

    function updatePaginationInfo(data) {
        const paginationInfo = document.querySelector('.dealers-page__pagination-info');
        
        if (!paginationInfo) {
            return;
        }

        paginationInfo.dataset.page = data.current_page;
        paginationInfo.dataset.totalPages = data.total_pages;
        paginationInfo.dataset.totalDealers = data.total_count;

        if (data.has_more) {
            paginationInfo.style.display = 'block';
            const countSpan = paginationInfo.querySelector('.dealers-page__pagination--count');
            if (countSpan) {
                countSpan.textContent = 'Visar ' + (data.current_page * 20) + ' av ' + data.total_count + ' återförsäljare';
            }
        } else {
            paginationInfo.style.display = 'none';
            const countSpan = paginationInfo.querySelector('.dealers-page__pagination--count');
            if (countSpan) {
                countSpan.textContent = 'Visar alla ' + data.total_count + ' återförsäljare';
            }
        }
    }

    document.getElementById('dealers-filter-form')?.addEventListener('submit', function(event) {
        event.preventDefault();
        const selectedRegion = document.querySelector('select[name="region"]').value;
        // Set flag to prevent auto-load after form submission
        justFiltered = true;
        filterDealers(selectedRegion);
        
        // Reset flag after a delay
        setTimeout(() => {
            justFiltered = false;
        }, 1000);
    });

    // Auto-load more when scrolling near the bottom
    let isLoading = false;
    let justFiltered = false; // Flag to prevent auto-load after filtering
    
    window.addEventListener('scroll', function() {
        if (isLoading || justFiltered) {
            return;
        }
        
        const paginationInfo = document.querySelector('.dealers-page__pagination-info');
        if (!paginationInfo) {
            return;
        }
        
        if (paginationInfo.style.display === 'none') {
            return;
        }
        
        const rect = paginationInfo.getBoundingClientRect();
        const isVisible = rect.top <= window.innerHeight + 1500; // Load when element is 300px from viewport
        
        if (isVisible) {
            isLoading = true;
            loadMoreDealers().finally(() => {
                isLoading = false;
            });
        }
    });

    // Sticky filter behavior
    function handleStickyFilter() {
        const filter = document.querySelector('.dealers-page__filter');
        if (!filter) return;

        const filterRect = filter.getBoundingClientRect();
        const isSticky = filterRect.top <= 220;

        if (isSticky) {
            filter.classList.add('sticky');
        } else {
            filter.classList.remove('sticky');
        }
    }

    // Add scroll event listener for sticky filter
    window.addEventListener('scroll', handleStickyFilter);

    regionRedirect();

    function setVehicleTypeFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const types = urlParams.getAll('type');
        const typeMap = {
            husbil: 'husbilar',
            husvagn: 'husvagnar'
        };
        types.forEach(t => {
            const value = typeMap[t] || t;
            const checkbox = document.querySelector(`input[name="vehicle_type[]"][value="${value}"]`);
            if (checkbox) {
                checkbox.checked = true;
            }
        });

        const region = urlParams.get('region') || '';
        // Set flag to prevent auto-load after initial load
        justFiltered = true;
        filterDealers(region);
        
        // Reset flag after a delay
        setTimeout(() => {
            justFiltered = false;
        }, 1000);
    }
    
    setVehicleTypeFromUrl();
    regionRedirect();
});